import { render, staticRenderFns } from "./ShopBar.vue?vue&type=template&id=58e1330c&"
import script from "./ShopBar.vue?vue&type=script&lang=js&"
export * from "./ShopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports